import React, { useEffect, useState } from 'react';
import './Navbar.css';
import logo from '../assets/logo.png';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 35) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    setIsVisible(true);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isVisible ? 'animate-slideInDown' : ''}`}>
      <div className="navbar-container">
        <div className="logo animate-fadeIn">
          <Link to="/">
            <img src={logo} alt="Basketball Culture Logo" />
          </Link>
        </div>
        
        <div className="nav-links">
          {['HOME', 'EPISODES', 'ABOUT', 'CONTACT'].map((link, index) => (
            <Link 
              key={link} 
              to={link === 'HOME' ? '/' : `/${link.toLowerCase()}`}
              className={`animate-fadeInUp stagger-delay-${index}`}
            >
              {link}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;